import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageview } from "./ga";

export default function useAnalytics() {
  const location = useLocation();
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);
}